// extracted by mini-css-extract-plugin
export default {"wrapper":"PublicPageLayout_wrapper__uq9cH"};